/**
 * 创建页「台本图怎么扣」那一句 —— PC 创建页两个入口(intakeAction / 目的流右栏 CTA)共用。
 *
 * ═══ 0926 修的是什么 ═══════════════════════════════════════════════════════════
 * 旧句「台本图每镜 66 积分,勾了才按镜数扣」两处都不对(演示机实测两条真单):
 *   ① **不勾也扣**:api `VideoDraftFrameService.generateFrames` 的规则是「非 T2V 镜(会当出片
 *      起始画面的镜)**必出**首帧;勾选框(`previewFrames === true`)只决定 T2V 镜要不要**额外**
 *      出预览图」。r1 3 镜 1 段扣 1 张、r2 6 镜 3 段扣 3 张,复选框都没勾。规则本就如此
 *      (首帧是 I2V 渲染输入,不出就没法按图出片),所以改的是文案,不是规则。
 *   ② **单价错**:66 是 `poster.image/openai_2K` 的价;首帧结算走 `video.frame`,实扣 90。
 *      单价现在由调用方从价目表 `SKU.videoFrame` 取(后端按首帧恒 2K 报价),本函数只拼句子。
 *
 * ★拿不到单价 → 只说规则不说数(`?? 0` 会印出「每张 0 积分」,用户会当成免费)。
 *
 * ═══ 1005 生产实测再修 ═══════════════════════════════════════════════════════════
 * 「会用于出片的镜」被读成「所有要出片的镜」:珠宝硬广 3 镜编排完全部是文生镜(T2V,导演把产品图
 * 挂成参考而不是起始画面),api `generateFrames` 照规则一张不出、一分不扣(编排 746 全是编排费),
 * 用户却按文案等 3 张台本图。改成说清「哪种镜才出」+「文生镜不出也不扣」。
 */
export function frameRuleCaption(
  perFrameCredits: number | null | undefined,
  opts?: { manualTextOnly?: boolean }
): string {
  const price = perFrameCredits == null ? "按张扣" : `每张 ${perFrameCredits} 积分,按张扣`;
  const base = `要当起始画面的镜(图生镜)自动出台本图(通常每段 1 张),${price};文生镜不出图、不扣台本图费;勾上则每个镜头都出`;
  if (!opts?.manualTextOnly) return base;
  // ★1006 定口径:api 5599e4c4 起手选文生编排后各镜强制文生 —— 不出台本图、不扣台本图费。
  //   d8c50ce2 那句「AI 编排仍可能排图生镜并出台本图(带单价)」已不成立,删掉;只在用户自己
  //   勾了「每个镜头都出」时才出图(复选框旁已写「按镜数加钱」,这里不再报台本图费)。
  return "你手选了文生模型:各镜都按文生出片,不出台本图;想看每镜预览可勾上「每个镜头都出」";
}

/** 用户是否**手动**锁定了文生(手动选型 + 生成模式文生,或所选模型不支持图生)。 */
export function isManualTextOnly(args: {
  useAutoModel: boolean;
  generationMode?: string | null;
  supportedGenerationModes?: readonly string[] | null;
}): boolean {
  if (args.useAutoModel) return false;
  if (args.generationMode === "T2V") return true;
  const modes = args.supportedGenerationModes;
  return !!modes && modes.length > 0 && !modes.some((m) => m.startsWith("I2V"));
}

/**
 * 编排按钮文案里的「台本图」要不要提(1006 演示机复测:手选文生、最终 0 张台本图,编排期间按钮却写
 * 「逐镜出台本图中...」)。api 5599e4c4 起手选文生编排后各镜强制文生、不出台本图;只有勾了「每个镜头
 * 都出台本图」才会出。
 */
export function composeMentionsFrames(args: {
  manualTextOnly: boolean;
  previewFrames?: boolean | null;
}): boolean {
  return !args.manualTextOnly || args.previewFrames === true;
}

/** 编排进行中(framingBatch)按钮文案。 */
export function framingBusyLabel(mentionsFrames: boolean): string {
  return mentionsFrames ? "逐镜出台本图中..." : "编排分镜中...";
}

/** 编排按钮里括号那段:提台本图 →「分镜 + 台本图」,否则只「分镜」。 */
export function composeScopeLabel(mentionsFrames: boolean): string {
  return mentionsFrames ? "分镜 + 台本图" : "分镜";
}
